export default __webpack_public_path__ + "static/media/qrcode-teste.994cf990.jpg";